import React, { PureComponent } from 'react';

import { connect } from 'react-redux';
import { Link } from 'react-router-dom';

import { enquireScreen } from 'enquire-js';

import { getAuthority } from '@/auth/authority';
import Auths from '@/auth/Auths';

class Logo extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      isMobile: false,
    };
  }

  calculateVM = string => {
    const len = string.length;
    if (len < 20) return '2vw';
    if (len < 30) return '1.7vw';
    if (len < 40) return '1.35vw';
    return '0.9vw';
  };

  render() {
    const { isMobile } = this.state;
    const { appName } = this.props.systemResult;
    const { appLogo } = this.props.systemResult;
    // TODO: 这边在不同端，为了显示下所有系统名字的样式判断只是暂时应付，后期优化;
    return (
      <div
        className="logo"
        // style={!isMobile ? { maxWidth: '60%' } : {}}
      >
        <Link
          to={getAuthority().includes(Auths.ADMINISTRATOR) ? '/company' : '/'}
          className="logo-text"
          style={{
            fontSize: !isMobile ? this.calculateVM(appName) : 16,
            display: 'flex',
            alignItems: 'center',
          }}
        >
          {appLogo && (
            <img
              src={`${appLogo}?time=${new Date().getTime()}`}
              style={{ width: 50, height: 50, marginRight: 6 }}
            />
          )}
          {/* 🔓 */}
          {appName}
        </Link>
      </div>
    );
  }

  componentDidMount() {
    this.enquireScreenRegister();
  }

  enquireScreenRegister = () => {
    const mediaCondition = 'only screen and (max-width:720px)';
    enquireScreen(mobile => {
      this.setState({
        isMobile: mobile,
      });
    }, mediaCondition);
  };
}

function mapStateToProps(store) {
  return {
    systemResult: store.systemReducer,
  };
}

export default connect(mapStateToProps)(Logo);
